const network = require("./net.config");
const setting = require("./setting.config");
const xbt = require("./xbt.config");

module.exports = Object.assign({}, network, setting, xbt);
